<div
	class="container-fluid noprint tw-bg-para-primary tw-shadow-sm tw-min-h-[80px] tw-transition-all tw-duration-500"
	[style.borderBottom]="'6px solid ' + getAssessmentColor(seriesItem?.assessmentId)"
>
	<div *ngIf="authenticationService.isAuthenticated()" class="tw-w-full tw-min-h-[80px] tw-flex tw-items-center tw-justify-between tw-gap-4 tw-py-3 tw-px-3 md:tw-px-6 2xl:tw-px-10 tw-max-w-screen-2xl tw-mx-auto" >
		<div class="tw-flex tw-items-center tw-min-w-0">
			<div class="tw-flex tw-items-center tw-h-full">
				<div class="tw-text-left tw-leading-none">
					<div class="tw-flex tw-items-baseline tw-gap-2 tw-flex-wrap tw-leading-none">
						<div class="tw-text-[11px] md:tw-text-[12px] tw-font-semibold tw-uppercase tw-tracking-[0.26em] tw-text-white/80">
							PARA
						</div>

					</div>
					<div class="tw-mt-1.5 tw-min-w-0 tw-pr-2">
						<div class="tw-flex tw-flex-col tw-gap-1 tw-min-w-0">
							<div class="tw-flex tw-items-center tw-gap-3 tw-min-w-0" [attr.aria-busy]="pageTitleLoading">
								<span
									*ngIf="!pageTitleLoading"
									class="tw-block tw-min-w-0 tw-max-w-[min(100vw-10rem,720px)] tw-text-[17px] md:tw-text-[21px] tw-font-bold tw-tracking-tight tw-text-white tw-leading-snug tw-break-words"
									[attr.aria-label]="pageTitle"
									[attr.title]="pageTitle"
								>
									{{ pageTitle }}
								</span>
								<div
									*ngIf="pageTitleLoading"
									class="tw-min-w-0 tw-animate-pulse"
									role="status"
									aria-label="Loading assessment title"
								>
									<div class="tw-h-[18px] md:tw-h-[22px] tw-w-[min(320px,72vw)] tw-max-w-[520px] tw-rounded-md tw-bg-white/25"></div>
								</div>
							</div>

							<!-- <div *ngIf="seriesItems.length > 1" class="tw-text-[10px] tw-font-semibold tw-text-white/60 tw-tracking-wide">
								{{ seriesUnlockLabel }}
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="noprint tw-hidden sm:tw-flex tw-items-center tw-justify-center tw-flex-1 tw-min-w-0">

				<img class="logo tw-h-8 md:tw-h-9 tw-w-auto" src="assets/img/CL-horizontal-white.svg" alt="Confident Learners" />

		</div>

		<div class="noprint tw-flex tw-items-center tw-justify-end tw-min-w-0 tw-gap-3">
			<div class="dropdown noprint tw-relative">
				<button
					type="button"
					class="tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer tw-transition-opacity hover:tw-opacity-90 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-white/30 tw-rounded-full"
					id="paraUserDropdown"
					data-bs-toggle="dropdown"
					aria-expanded="false"
					aria-haspopup="true"
				>
					<div class="tw-flex tw-items-center tw-gap-3">
						<div class="tw-w-11 tw-h-11 tw-rounded-full tw-bg-white/15 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-ring-1 tw-ring-white/25">
							<span class="tw-text-white tw-font-semibold tw-text-base tw-leading-none tw-uppercase md:tw-text-sm">{{ userInitials }}</span>
						</div>
						<div class="tw-hidden md:tw-flex tw-flex-col tw-items-start">
							<span
								data-para-redact
								class="tw-text-white tw-font-medium tw-text-[14px] tw-leading-tight tw-whitespace-nowrap tw-max-w-[220px] tw-overflow-hidden tw-text-ellipsis"
							>
								Welcome, {{ userName || 'User' }}
							</span>
							<small class="tw-text-white/80 tw-text-[12px] tw-leading-tight">{{ roleLabel }}</small>
						</div>
					</div>
				</button>

				<div
					class="dropdown-menu dropdown-menu-end tw-min-w-[280px] tw-p-0 tw-bg-white/95 tw-backdrop-blur-md tw-border tw-border-white/20 tw-rounded-2xl tw-shadow-para-dropdown tw-mt-4 tw-overflow-hidden tw-animate-in tw-fade-in tw-slide-in-from-top-2 tw-duration-200"
					aria-labelledby="paraUserDropdown"
				>
					<div class="tw-p-5 tw-bg-slate-900/5 tw-border-b tw-border-slate-200/50">
						<div class="tw-flex tw-items-center">
							<div class="tw-w-12 tw-h-12 tw-rounded-full tw-bg-para-primary tw-flex tw-items-center tw-justify-center tw-ring-4 tw-ring-white/50 tw-shadow-md tw-mr-4">
								<span class="tw-text-white tw-font-bold tw-text-[20px] tw-leading-none tw-uppercase">{{ userInitials }}</span>
							</div>
							<div class="tw-flex tw-flex-col tw-min-w-0">
								<span data-para-redact class="tw-font-bold tw-text-slate-900 tw-text-base tw-truncate"> {{ userName || 'User' }}</span>
								<small class="tw-text-slate-500 tw-font-medium tw-tracking-wide tw-text-[11px]">{{ roleLabel }}</small>
							</div>
						</div>
					</div>

					<div class="tw-py-1">
						<a class="tw-px-6 tw-py-3 tw-flex tw-items-center tw-gap-3 tw-transition-colors tw-cursor-pointer tw-text-[14px] tw-font-medium hover:tw-bg-para-primary/5 tw-no-underline tw-text-para-primary hover:tw-text-para-primary" href="/landing">
							<i class="fa fa-home tw-w-4"></i>
							Home
						</a>
					</div>
					<div class="tw-border-t tw-border-slate-100"></div>
					<div class="tw-py-1">
						<button
							type="button"
							class="tw-w-full tw-text-left tw-px-6 tw-py-3 tw-flex tw-items-center tw-gap-3 tw-transition-colors tw-cursor-pointer tw-text-[14px] tw-font-bold tw-text-red-600 hover:tw-bg-red-50 tw-bg-transparent tw-border-0"
							(click)="logout()"
						>
							<i class="fa fa-sign-out tw-w-4"></i>
							Sign out
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="tw-min-h-[calc(100vh-148px)] tw-bg-para-surface" [style.--para-card-gradient]="assessmentCardGradient">
	<div class="tw-w-full">
		<router-outlet></router-outlet>
		<app-para-lms-assessment class="noprint"></app-para-lms-assessment>
	</div>
</div>

<footer class="noprint tw-bg-para-primary tw-h-[68px] tw-border-t tw-border-slate-200 tw-flex tw-items-center tw-justify-center">
	<div class="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-border-t-4 tw-border-para-primary">
		<app-para-footer class="noprint"></app-para-footer>
	</div>
</footer>
